<script>
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
export default {
    components: {
        MaskedInput
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        busy: {
            type: Boolean,
            default: false
        },
        selectable: {
            type: Boolean,
            default: false
        },
        selectMultiple: {
            type: Boolean,
            default: false
        },
        perPage: {
            type: Number,
            default: 30
        },
        withFilter: {
            type: Boolean,
            default: false
        },
        categories: {
            type: Array,
            default: () => []
        },
        carts: {
            type: Array,
            default: () => []
        },
        returnCount: {
            type: Number,
            default: 0
        },
        viewOnly: {
            type: Boolean,
            default: false
        },
        remainingResult: {
            type: Number,
            default: 0
        },
        loadingMore: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        filtered(){
            let data = this.items;
            // var total = this.currentPage * this.perPage;
            // if (this.filter.trim() != "" && this.filter) {
            //     data = data.filter((item) => {
            //         return item.filterKey
            //             .toUpperCase()
            //             .includes(this.filter.toUpperCase());
            //     });
            // }
            if(this.categoryFilter != 0){
                data = data.filter((item) => {
                    return item.itemCategoryId == this.categoryFilter
                });
            }
            // if (this.priceModel === 'above5M') {
            //     data = data.filter((item) => {
            //         return item.unitCost > 5000000
            //     });
            // }else if(this.priceModel === 'below5M'){
            //     data = data.filter((item) => {
            //         return item.unitCost > 1000000 && item.unitCost < 5000000
            //     });
            // }else if(this.priceModel === 'below1M'){
            //     data = data.filter((item) => {
            //         return item.unitCost < 1000000
            //     });
            // }
            if(this.unitCostFrom && this.unitCostTo){
                let from = this.getExactAmt(this.unitCostFrom);
                let to = this.getExactAmt(this.unitCostTo);
                data = data.filter((item) => {
                    return item.unitCost >= from && item.unitCost <= to
                });
            }
            if(this.filterType === 'CSE'){
                data = data.filter((item) => {
                    return item.type == 'CSE'
                });
            }else if(this.filterType === 'NON-CSE'){
                data = data.filter((item) => {
                    return item.type == 'NON-CSE'
                });
            }
            if(this.filterSubType !== 'All'){
                data = data.filter((item) => {
                    return item.subType == this.filterSubType
                });
            }
            // var currentData = data.slice(total - this.perPage, total);
            // if (this.currentPage > 1 && currentData.length == 0) {
            //     total = (this.currentPage - 1) * this.perPage;
            //     currentData = data.slice(total - this.perPage, total);
            // }
            return data;
        },
        rows(){
            let data = this.items;
            // if (this.filter.trim() != "" && this.filter) {
            //     data = data.filter((item) => {
            //         return item.filterKey
            //             .toUpperCase()
            //             .includes(this.filter.toUpperCase());
            //     });
            // }
            if(this.categoryFilter != 0){
                data = data.filter((item) => {
                    return item.itemCategoryId == this.categoryFilter
                });
            }
            // if (this.priceModel === 'above5M') {
            //     data = data.filter((item) => {
            //         return item.unitCost > 5000000
            //     });
            // }else if(this.priceModel === 'below5M'){
            //     data = data.filter((item) => {
            //         return item.unitCost > 1000000 && item.unitCost < 5000000
            //     });
            // }else if(this.priceModel === 'below1M'){
            //     data = data.filter((item) => {
            //         return item.unitCost < 1000000
            //     });
            // }
            // if(this.filterType === 'CSE'){
            //     data = data.filter((item) => {
            //         return item.type == 'CSE'
            //     });
            // }else if(this.filterType === 'NON-CSE'){
            //     data = data.filter((item) => {
            //         return item.type == 'NON-CSE'
            //     });
            // }
            // if(this.filterSubType !== 'All'){
            //     data = data.filter((item) => {
            //         return item.subType == this.filterSubType
            //     });
            // }
            return data.length;
        },
        filteredCategory(){
            let data = this.categories;
            var total = this.currentItemCat * 10;
            if (this.filterCat.trim() != "" && this.filterCat) {
                data = data.filter((item) => {
                    return item.name
                        .toUpperCase()
                        .includes(this.filterCat.toUpperCase());
                });
            }
            var currentData = data.slice(total - 10, total);
            if (this.currentItemCat > 1 && currentData.length == 0) {
                total = (this.currentItemCat - 1) * 10;
                currentData = data.slice(total - 10, total);
            }
            return currentData;
        },
        itemRows(){
            let data = this.categories;
            if (this.filterCat.trim() != "" && this.filterCat) {
                data = data.filter((item) => {
                    return item.name
                        .toUpperCase()
                        .includes(this.filterCat.toUpperCase());
                });
            }
            return data.length;
        },
        filterWasChanged(){
            if(this.lastSearch){
                let searchNow = {
                    search: this.filter,
                    amountFrom: this.getExactAmt(this.unitCostFrom || 0) || 0,
                    amountTo: this.getExactAmt(this.unitCostTo || 0) || 0,
                };
                return JSON.stringify(searchNow) !== this.lastSearch;
            }
            return false;
        }
    },
    data(){
        return {
            filter: "",
            pageOptions: [10, 30, 50, 100],
            currentPage: 1,
            priceModel: 'All',
            filterType: 'ALL',
            filterSubType: 'All',
            categoryFilter: 0,
            filterCat: "",
            currentItemCat: 1,
            submitFilter: false,
            unitCostFrom: null,
            unitCostTo: null,
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
            lastSearch: null,
        }
    },
    methods: {
        requestItem(){
            this.$emit('request-item');
        },
        selectThisItem(item){
            if(!this.selectable && !this.selectMultiple) return;
            if(this.selectMultiple){
                this.$emit('select-item', item);
            }else{
                this.$emit('selected-item', item);
            }
        },
        submitSearch(){
            this.submitFilter = this.filter ? true : false;
            let data = {
                search: this.filter,
                amountFrom: this.getExactAmt(this.unitCostFrom || 0) || 0,
                amountTo: this.getExactAmt(this.unitCostTo || 0) || 0,
            }
            this.$emit('search-item', data);
            this.lastSearch = JSON.stringify(data);
        },
        loadMore(){
            this.$emit('load-more');
        }
    }
}
</script>
<template>
    <div class="row">
        <div :class="{'col-md-12': selectable, 'col-md-9 position-relative': !selectable}">
            <!-- <div class="text-warning">
                *Request an item feature was disable right now. Please wait until further notice.
            </div> -->
            <div v-if="selectable && !submitFilter" class="mb-3 d-flex gap-2 justify-content-end w-100">
                <div>
                    <label class="mb-0">Unit Cost From</label>
                    <masked-input
                        autocomplete="off"
                        type="text"
                        v-model="unitCostFrom"
                        class="form-control"
                        :mask="currencyMask"
                        list="unitCostOptions"
                    >
                    </masked-input>
                        <!-- @keydown.enter="submitSearch" -->
                </div>
                <div>
                    <label class="mb-0">Unit Cost To</label>
                    <masked-input
                        autocomplete="off"
                        type="text"
                        v-model="unitCostTo"
                        class="form-control"
                        :mask="currencyMask"
                        list="unitCostOptions"
                    >
                    </masked-input>
                        <!-- @keydown.enter="submitSearch" -->
                </div>
            </div>
            <div class="d-flex justify-content-between mt-0 mt-trans" :class="{'w-100 mt-120px': !submitFilter, 'mb-3': submitFilter}">
                <form @submit.prevent="submitSearch" :class="{'w-100': !submitFilter, 'd-flex gap-2 w-100 align-items-center': submitFilter}">
                    <div :class="{'w-50': submitFilter, 'w-100': !submitFilter}">
                        <label for="Search" class="mb-0 ms-2 mb-0" v-if="selectable">Search</label>
                        <div class="position-relative">
                            <input type="search" class="form-control" :style="{borderRadius: '25px'}" :class="{'custom-search w-100': !submitFilter, 'h-100': selectable && submitFilter}" placeholder="Type your item query here and hit enter" v-model="filter" />
                            <button type="submit" class="btn btn-success position-absolute d-flex align-items-center" :class="{'btn-lg': !submitFilter, 'btn-sm': submitFilter}" :style="{top: '50%', right: '8px', borderRadius: '25px', transform: 'translateY(-50%)'}"><i class="bx bx-search me-1"></i>Search</button>
                        </div>
                    </div>
                    <template v-if="selectable && submitFilter">
                        <div>
                            <label class="mb-0">Unit Cost From</label>
                            <masked-input
                                autocomplete="off"
                                type="text"
                                v-model="unitCostFrom"
                                class="form-control"
                                :mask="currencyMask"
                                list="unitCostOptions"
                            >
                            </masked-input>
                        </div>
                        <div>
                            <label class="mb-0">Unit Cost To</label>
                            <masked-input
                                autocomplete="off"
                                type="text"
                                v-model="unitCostTo"
                                class="form-control"
                                :mask="currencyMask"
                                list="unitCostOptions"
                            >
                            </masked-input>
                        </div>
                        <div style="width:150px;">
                            <template v-if="remainingResult > 0 && !filterWasChanged">
                                <button class="btn btn-success btn-block mt-3" @click="loadMore"><i class="bx bx-search"></i> Load more</button>
                            </template>
                            <template v-else>
                                <button class="btn btn-success btn-block mt-3" @click="submitSearch"><i class="bx bx-search"></i> Search</button>
                            </template>
                        </div>
                    </template>
                </form>
            </div>
            <div class="d-flex align-items-center gap-2 position-absolute" style="right:0;top:0;">
                <!-- <div>
                    <label for="categoryFilter" class="mb-0">Category</label>
                    <b-form-select
                        class="form-select"
                        v-model="categoryFilter"
                        style="width:350px;"
                        v-if="withFilter"
                    >
                        <b-form-select-option value="0">All Category</b-form-select-option>
                        <b-form-select-option
                            v-for="category in categories"
                            :key="category.id"
                            :value="category.id"
                        >
                            {{category.name}}
                        </b-form-select-option>
                    </b-form-select>
                </div> -->
                <div class="position-relative cursor-pointer" v-if="!selectable"  @click="$emit('show-cart')">
                    <i class="bx bx-shopping-bag ms-1" style="font-size:24px;"></i>
                    <small class="position-absolute badge bg-danger rounded-pill font-size-10 ms-1" style="top:-5px;right:-10px;" v-if="carts.length != 0" >{{carts.length}}</small>
                </div>
                <button type="button" class="btn btn-gradient-primary px-3" @click="requestItem" v-if="!selectable && !viewOnly"><span class="position-relative"><i class="bx bx-receipt me-1"></i> Request an Item <small class="position-absolute badge bg-danger font-size-10 ms-1" style="right:-12px;" v-if="returnCount > 0">{{returnCount}}</small></span></button>
            </div>
            <div class="row" v-if="!busy && filtered.length">
                <div class="col-md-6" v-for="item in filtered" :key="item.id">
                    <div class="card mb-2" :class="{'cursor-pointer': (selectable && !viewOnly) || selectMultiple}">
                        <div class="card-body p-0 position-relative">
                            <div class="position-absolute" style="right:5px;top:5px;" v-if="selectMultiple">
                                <div
                                    class="
                                        form-check
                                        form-checkbox-outline
                                        form-check-success
                                        mb-0
                                    "
                                >
                                    <input
                                        type="checkbox"
                                        id="customCheckcolor2"
                                        class="form-check-input"
                                        v-model="item.selected"
                                    />
                                </div>
                            </div>
                            <div class="position-absolute d-flex align-items-center" style="width:54px;top:0;left:0;bottom:0;background:rgba(0, 0, 0, 0.4);border-radius:5px 0 0 5px;">
                                <div>
                                    <div v-if="item.thumbnail">
                                        <img
                                            :src="`${$store.state.data.rootFileDirectory}Procurement/${item.thumbnail}`"
                                            style="width:50px;margin-left:2px;"
                                            referrerpolicy="no-referrer"
                                        />
                                    </div>
                                    <div
                                        v-else
                                        class="
                                            d-flex
                                            align-items-center
                                            justify-content-center
                                            bg-success bg-gradient
                                        "
                                        style="height:50px;width:50px;margin-left:2px;"
                                    >
                                        <i class="bx bx-user text-white font-size-24"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="my-2" style="width:calc(100% - (50px + 2rem));margin-left:64px;">
                                <h5 class="mb-0 hover-link" @click="selectThisItem(item)">{{item.itemName}}</h5>
                                <p 
                                    class="mb-0 hover-underline" 
                                    :class="{'text-ellipsis': !item.descriptionClicked}" 
                                    @click="item.descriptionClicked = !item.descriptionClicked"
                                >
                                    {{item.description}}
                                </p>
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <span class="badge bg-primary bg-soft me-1">{{item.unit.unitName}}</span>
                                        <span class="badge bg-primary bg-soft me-1">{{item.type}}</span>
                                        <span class="badge bg-primary bg-soft me-1" v-if="item.isProcurable">{{item.subType}}</span>
                                        <span class="badge bg-primary bg-soft text-normal">{{item.itemCategory.name}}</span>
                                    </div>
                                    <div class="text-right">
                                        <p class="mb-0 font-size-15 text-green font-weight-bold">{{formatCurrency(item.unitCost)}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="busy" class="mt-2">
                <h4>Loading...</h4>
            </div>
            <div v-if="loadingMore" class="mt-2">
                <h4>Loading more...</h4>
            </div>
            <div v-if="!busy && filtered.length == 0 && submitFilter" class="mt-2">
                <h4>Search not found...</h4>
            </div>
            <div class="mt-2" v-if="!loadingMore && !busy && remainingResult > 0">
                <button type="button" class="btn btn-block btn-outline-primary" @click="loadMore">Load More</button>
            </div>
            <!-- <div class="text-center mt-2" v-if="filtered.length">
                <ul
                    class="
                        pagination
                        justify-content-center
                        pagination-rounded
                    "
                >
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                </ul>
            </div> -->
        </div>
        <div class="col-md-3" v-if="!selectable">
            <h5 class="mb-3 mt-2">Filters:</h5>
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6">
                            <p class="mb-1">Type <i class="bx bx-chevron-down"></i></p>
                            <ul>
                                <li class="cursor-pointer" @click="filterType = 'ALL'" :class="{'text-green font-weight-bold': filterType === 'ALL'}">ALL</li>
                                <li class="cursor-pointer" @click="filterType = 'CSE'" :class="{'text-green font-weight-bold': filterType === 'CSE'}">CSE</li>
                                <li class="cursor-pointer" @click="filterType = 'NON-CSE'" :class="{'text-green font-weight-bold': filterType === 'NON-CSE'}">NON-CSE</li>
                            </ul>
                        </div>
                        <div class="col-md-6">
                            <p class="mb-1">Subtype <i class="bx bx-chevron-down"></i></p>
                            <ul>
                                <li class="cursor-pointer" :class="{'text-green font-weight-bold': filterSubType === 'All'}" @click="filterSubType = 'All'">ALL</li>
                                <li class="cursor-pointer" :class="{'text-green font-weight-bold': filterSubType === 'Goods'}" @click="filterSubType = 'Goods'">GOODS</li>
                                <li class="cursor-pointer" :class="{'text-green font-weight-bold': filterSubType === 'Services'}" @click="filterSubType = 'Services'">SERVICES</li>
                                <li class="cursor-pointer" :class="{'text-green font-weight-bold': filterSubType === 'Consultancy'}" @click="filterSubType = 'Consultancy'">CONSULTANCY</li>
                                <li class="cursor-pointer" :class="{'text-green font-weight-bold': filterSubType === 'Infrastructure'}" @click="filterSubType = 'Infrastructure'">INFRASTRUCTURE</li>
                            </ul>
                        </div>
                    </div>
                    <div class="mb-2">
                        <p class="mb-2">Unit Cost <i class="bx bx-chevron-down"></i></p>
                        <div class="d-flex align-items-center gap-2">
                            <label class="mb-0">From</label>
                            <masked-input
                                autocomplete="off"
                                type="text"
                                v-model="unitCostFrom"
                                class="form-control"
                                :mask="currencyMask"
                                list="unitCostOptions"
                            >
                            </masked-input>
                            <label class="mb-0">To</label>
                            <masked-input
                                autocomplete="off"
                                type="text"
                                v-model="unitCostTo"
                                class="form-control"
                                :mask="currencyMask"
                                list="unitCostOptions"
                            >
                            </masked-input>
                            <datalist id="unitCostOptions">
                                <option>0</option>
                                <option>500,000</option>
                                <option>1,000,000</option>
                                <option>5,000,000</option>
                                <option>10,000,000</option>
                            </datalist>
                        </div>
                        <template v-if="remainingResult > 0 && !filterWasChanged">
                            <button class="btn btn-success btn-block mt-3" @click="loadMore"><i class="bx bx-search"></i> Load more</button>
                        </template>
                        <template v-else>
                            <button class="btn btn-success btn-block mt-3" @click="submitSearch"><i class="bx bx-search"></i> Search</button>
                        </template>
                        <!-- <ul>
                            <li class="cursor-pointer" @click="priceModel = 'All'" :class="{'text-green font-weight-bold': priceModel === 'All'}">All</li>
                            <li class="cursor-pointer" @click="priceModel = 'above5M'" :class="{'text-green font-weight-bold': priceModel === 'above5M'}">Above 5 Million</li>
                            <li class="cursor-pointer" @click="priceModel = 'below5M'" :class="{'text-green font-weight-bold': priceModel === 'below5M'}">Above 1 Million but less than 5 Million</li>
                            <li class="cursor-pointer" @click="priceModel = 'below1M'" :class="{'text-green font-weight-bold': priceModel === 'below1M'}">Below 1 Million</li>
                        </ul> -->
                    </div>
                    <!-- <div>
                        <p class="mb-1">Item Category <i class="bx bx-chevron-down"></i></p>
                        <ul>
                            <li class="cursor-pointer" @click="categoryFilter = 0" :class="{'text-green font-weight-bold': categoryFilter == 0}">All</li>
                            <li class="cursor-pointer" @click="categoryFilter = x.id" :class="{'text-green font-weight-bold': categoryFilter == x.id}" v-for="x in filteredCategory" :key="x.id">
                                {{ x.name }}
                            </li>
                        </ul>
                        <div class="text-center mt-2" v-if="filteredCategory.length">
                            <ul
                                class="
                                    pagination
                                    justify-content-end
                                "
                            >
                                <b-pagination
                                    size="sm"
                                    v-model="currentItemCat"
                                    :total-rows="itemRows"
                                    :per-page="10"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>